import { useEffect } from "react";

const Modal = ({ isVisible, onClose, content }) => {
  useEffect(() => {
    if (isVisible) {
      document.body.classList.add("modal-open");
    } else {
      document.body.classList.remove("modal-open");
    }
    return () => {
      document.body.classList.remove("modal-open");
    };
  }, [isVisible]);

  if (!isVisible) return null;

  return (
    <div className="modal" style={{ display: "block" }} onClick={onClose}>
      <div className="modal-dialog" onClick={(e) => e.stopPropagation()}>
        <div className="modal-content">
          <div className="modal-body">
            <button type="button" className="close" onClick={onClose}>
              &times;
            </button>
            <div className="pop-cont-area">
              <div className="pop-img">
                <img
                  src={`${process.env.REACT_APP_IMAGE_URL}/${content?.field_director_image}`}
                />
              </div>
              <div className="pop-content mCustomScrollbar _mCS_1">
                {/* <h4 className="card-title">{content.title}</h4> */}
                <div
                  tabIndex={0}
                  dangerouslySetInnerHTML={{ __html: content?.body }}
                  className="text-justify"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Modal;
